// extracted by mini-css-extract-plugin
module.exports = {"list":"NavMenu_list__qk4JL","item":"NavMenu_item__jWNRC"};